module.exports = __webpack_public_path__ + "static/media/0075_Small.ff0fab1a.jpg";